module.exports = __webpack_public_path__ + "static/media/cover.c1b94a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/cover.jpg
// module id = 288
// module chunks = 0